import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';

import { useUserStore } from '@/configs/store';
import { useTimeLogStore } from '@/pages/TimesheetsPage/model';
import { WeeklyWorkLog } from '@/types';
import { formatDurationRussian } from '@/utils/formatDurationRussian';

import { TimeLogForm } from './TimeLogForm';
import { DataValues } from './types';
import { getInitialUsers } from './utils';

type CopyLogProps = {
  log: WeeklyWorkLog;
  open: boolean;
  onSubmit: (data: DataValues & { workLogId: string }) => Promise<void>;
  onClose: () => void;
  day: DateTime | null;
};

const CopyLog: React.FC<CopyLogProps> = observer(({ log, onClose, open, onSubmit, day }) => {
  const { user, isAdmin } = useUserStore();
  const {
    usersFilterModel: { selectedUserId, selectedUser, myUserId },
  } = useTimeLogStore();
  const { id, taskKey, taskTitle, durationMinutes, comment } = log;

  const today = DateTime.local().setLocale('ru').toISODate()!;

  const usersWithMyself = getInitialUsers({
    user,
    myUserId,
    isAdmin,
    selectedUserId,
    selectedUser,
  });

  const startDate = day?.toISODate() ?? today;

  const initialValues = {
    taskKey,
    taskLabel: `${taskKey} — ${taskTitle}`,
    comment: comment ?? '',
    users: usersWithMyself,
    dateEntries: [
      { startDate, duration: formatDurationRussian(durationMinutes), startTime: '12:00' },
    ],
  };

  const handleSubmit = async (data: DataValues) => {
    const values = {
      taskKey: data.taskKey,
      duration: data.duration,
      workLogId: id,
      comment: data.comment,
      startDate: data.startDate,
      usersIds: data.usersIds,
    };

    await onSubmit(values);
  };

  return (
    <TimeLogForm
      open={open}
      onClose={onClose}
      formValues={initialValues}
      onSubmit={handleSubmit}
      hasPreselectedDate={Boolean(day)}
      isCopy
    />
  );
});

export { CopyLog };
